import { TextField, TextFieldProps } from "../TextField";
// eslint-disable-next-line cohere-react/no-mui-styled-import
import { styled } from "@material-ui/core";
import { colorsLight } from "../../themes";
import { useFeature } from "../../components";
import { ReadingLevelChip } from "./ReadingLevelChip";
import { ReviewDenialReadingLevelConfiguration } from "@coherehealth/core-platform-api";

interface DenialLetterTextBoxWithGradeLevelProps extends TextFieldProps {
  denialReadingLevelConfig?: ReviewDenialReadingLevelConfiguration;
}

export function DenialLetterTextBoxWithGradeLevel({
  denialReadingLevelConfig,
  ...props
}: DenialLetterTextBoxWithGradeLevelProps) {
  const denialLetterReadingLevelFeatureEnabled = useFeature("denialLetterReadingLevel");
  const denialLetterReadingLevelEnabled = Boolean(
    denialLetterReadingLevelFeatureEnabled && denialReadingLevelConfig?.enabled
  );
  const shouldDisplayGradeLevel =
    denialLetterReadingLevelEnabled && props.value && String(props.value).trim().length > 0;
  return (
    <div
      style={{
        marginBottom: "24px",
      }}
    >
      <DenialLetterTextBox {...props} />
      <>
        {shouldDisplayGradeLevel && (
          <ReadingLevelChip text={String(props.value)} thresholds={denialReadingLevelConfig} />
        )}
      </>
    </div>
  );
}

// eslint-disable-next-line cohere-react/no-mui-styled-import
const DenialLetterTextBox = styled(TextField)(({ theme }) => ({
  "& .MuiFilledInput-root": {
    paddingTop: "10px",
    borderColor: colorsLight.gray.divider,
    backgroundColor: colorsLight.background.card,
    "&:hover,&.Mui-focused": {
      backgroundColor: colorsLight.background.card,
    },
    alignItems: "inherit",
  },
  "& .MuiInputBase-input": {
    color: colorsLight.font.main,
  },
}));
